import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-dd57bf94"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "form-radio" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("正常")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("不正常")
const _hoisted_4 = { class: "top-container" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" 人员选择器 ")
const _hoisted_6 = { class: "filterbox" }
const _hoisted_7 = { class: "container" }
const _hoisted_8 = ["src"]
const _hoisted_9 = { class: "username" }
const _hoisted_10 = /*#__PURE__*/_createTextVNode("确定")
const _hoisted_11 = { class: "remark" }
const _hoisted_12 = { class: "fujian" }
const _hoisted_13 = { class: "button" }
const _hoisted_14 = /*#__PURE__*/_createTextVNode("提交")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_nav_bar = _resolveComponent("van-nav-bar")!
  const _component_van_radio = _resolveComponent("van-radio")!
  const _component_van_radio_group = _resolveComponent("van-radio-group")!
  const _component_van_field = _resolveComponent("van-field")!
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_van_search = _resolveComponent("van-search")!
  const _component_van_cell_group = _resolveComponent("van-cell-group")!
  const _component_van_list = _resolveComponent("van-list")!
  const _component_van_pull_refresh = _resolveComponent("van-pull-refresh")!
  const _component_van_button = _resolveComponent("van-button")!
  const _component_van_popup = _resolveComponent("van-popup")!
  const _component_van_uploader = _resolveComponent("van-uploader")!
  const _component_van_form = _resolveComponent("van-form")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_van_nav_bar, {
      "left-arrow": "",
      title: _ctx.$route.meta.title,
      placeholder: "",
      onClickLeft: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.go(-1)))
    }, null, 8, ["title"]),
    _createVNode(_component_van_form, { onSubmit: _ctx.onSubmit }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_van_field, {
            rules: [{ required: true, message: '结果必选' }],
            required: "",
            label: "结果"
          }, {
            input: _withCtx(() => [
              _createVNode(_component_van_radio_group, {
                modelValue: _ctx.submitform.status,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.submitform.status) = $event))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_van_radio, { name: 1 }, {
                    default: _withCtx(() => [
                      _hoisted_2
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_van_radio, {
                    name: 2,
                    class: "second-radio"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_3
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }),
          (_ctx.submitform.status === 2)
            ? (_openBlock(), _createBlock(_component_van_field, {
                key: 0,
                class: "field",
                modelValue: _ctx.fieldValue,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.fieldValue) = $event)),
                "is-link": "",
                readonly: "",
                rules: [{ required: true, message: '请选择整改负责人' }],
                required: "",
                name: "picker",
                label: "整改负责人",
                placeholder: "请选择整改负责人",
                onClick: _ctx.showPopup
              }, null, 8, ["modelValue", "onClick"]))
            : _createCommentVNode("", true),
          _createVNode(_component_van_popup, {
            show: _ctx.show,
            "onUpdate:show": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.show) = $event)),
            round: "",
            position: "bottom",
            style: { height: '95%' },
            class: "popup"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_4, [
                _hoisted_5,
                _createElementVNode("span", {
                  onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.closePopup && _ctx.closePopup(...args)))
                }, [
                  _createVNode(_component_van_icon, { name: "cross" })
                ])
              ]),
              _createElementVNode("div", _hoisted_6, [
                _createVNode(_component_van_search, {
                  modelValue: _ctx.personName,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.personName) = $event)),
                  placeholder: "搜索"
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_7, [
                _createVNode(_component_van_pull_refresh, {
                  modelValue: _ctx.refreshing,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.refreshing) = $event)),
                  onRefresh: _ctx.onRefresh
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_van_list, {
                      loading: _ctx.loading,
                      "onUpdate:loading": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.loading) = $event)),
                      finished: _ctx.finished,
                      "finished-text": "没有更多了",
                      onLoad: _ctx.onLoad
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_van_radio_group, {
                          modelValue: _ctx.result,
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.result) = $event))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_van_cell_group, null, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.checkList, (item, index) => {
                                  return (_openBlock(), _createBlock(_component_van_radio, {
                                    key: index,
                                    name: item.userId
                                  }, {
                                    default: _withCtx(() => [
                                      (item.photoUrl)
                                        ? (_openBlock(), _createElementBlock("img", {
                                            key: 0,
                                            class: "img",
                                            src: item.photoUrl
                                          }, null, 8, _hoisted_8))
                                        : _createCommentVNode("", true),
                                      _createElementVNode("span", _hoisted_9, _toDisplayString(item.name), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["name"]))
                                }), 128))
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    }, 8, ["loading", "finished", "onLoad"])
                  ]),
                  _: 1
                }, 8, ["modelValue", "onRefresh"])
              ]),
              _createVNode(_component_van_button, {
                style: _normalizeStyle({ backgroundColor: _ctx.flag === true ? '#3f55f4' : '#9fabfe' }),
                block: "",
                type: "primary",
                onClick: _ctx.onFinish
              }, {
                default: _withCtx(() => [
                  _hoisted_10
                ]),
                _: 1
              }, 8, ["style", "onClick"])
            ]),
            _: 1
          }, 8, ["show"])
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createVNode(_component_van_field, {
            modelValue: _ctx.submitform.remark,
            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.submitform.remark) = $event)),
            label: "备注",
            placeholder: "请填写备注",
            maxlength: "200",
            "show-word-limit": "",
            rows: "2",
            autosize: "",
            type: "textarea"
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_12, [
          _createVNode(_component_van_field, {
            rules: [{ required: true, message: '请选择照片' }],
            required: "",
            label: "照片"
          }, {
            input: _withCtx(() => [
              _createVNode(_component_van_uploader, {
                modelValue: _ctx.uploader,
                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.uploader) = $event)),
                "after-read": _ctx.afterRead
              }, null, 8, ["modelValue", "after-read"])
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_13, [
          _createVNode(_component_van_button, {
            block: "",
            type: "primary",
            disabled: _ctx.isTrue,
            "native-type": "submit"
          }, {
            default: _withCtx(() => [
              _hoisted_14
            ]),
            _: 1
          }, 8, ["disabled"])
        ])
      ]),
      _: 1
    }, 8, ["onSubmit"])
  ]))
}